<template>
    <div>
        <h3>匹配测试工具</h3>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="职位id">
                <el-input v-model="filter.jobId" placeholder="职位id"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="fetch(1)" size="mini">匹配</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="userId" label="乙方id"></el-table-column>
            <el-table-column prop="nickname" label="乙方昵称">
                <template slot-scope="scope">
                    <a :href="`${frontUrl}/resume/detail/${scope.row.userIdEnc}`" target="_blank">{{scope.row.nickname}}</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'

const {
    match,
} = api

export default {
    name: 'job-list',
    data() {
        return {
            map,
            loading: false,
            list: [],
            filter: {
                jobId: '',
            },
        }
    },
    components: {},
    computed: {},
    watch: {},
    methods: {
        async fetch(num) {

            let {
                jobId,
            } = this.filter

            if (jobId) {
                this.loading = true
                let obj = {
                    jobId,
                }
                let res = await match.tool(obj)

                this.list = res.data.data
                this.loading = false
            } else {
                this.$message.error('请输入职位id');
            }

        },
    },
    mounted() {},
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/match/tool.vue